export enum CampaignReportType {
  VARIANT = 'variant',
  DEFAULT = 'customer',
  VARIANT_TIER = 'variant_tier',
  VARIANT_RFM = 'variant_rfm',
  CAMPAIGN_TIER = 'campaign_tier',
  CAMPAIGN_RFM = 'campaign_rfm'
}
